import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Lock, CreditCard, Clock, Check, AlertTriangle } from 'lucide-react';
import { Countdown } from './Countdown';
export function FinalCTA() {
  return <section className="py-14 bg-petroleum relative overflow-hidden border-t border-electric/20" data-id="element-254">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-glow pointer-events-none opacity-40" data-id="element-255"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-256">
        {/* Framed Countdown Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-10" data-id="element-257">
          <div className="absolute -inset-1 bg-gradient-to-r from-danger via-danger to-danger rounded-3xl blur-xl opacity-25 animate-pulse" data-id="element-258"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-danger rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-danger/20" data-id="element-259">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(255,90,90,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,90,90,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-260"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-danger rounded-tl-3xl pointer-events-none" data-id="element-261"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-danger rounded-tr-3xl pointer-events-none" data-id="element-262"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-danger rounded-bl-3xl pointer-events-none" data-id="element-263"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-danger rounded-br-3xl pointer-events-none" data-id="element-264"></div>

            <div className="relative z-10" data-id="element-265">
              <div className="inline-flex items-center gap-2 bg-danger text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-danger/40" data-id="element-266">
                <AlertTriangle className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-267" />
                Última oportunidad
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight mb-5" data-id="element-268">
                <span className="text-white" data-id="element-269">El precio </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-danger via-danger to-danger drop-shadow-[0_0_12px_rgba(255,90,90,0.4)]" data-id="element-270">
                  cierra en:
                </span>
              </h2>
              <Countdown data-id="element-271" />
              <div className="mt-5 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-danger to-transparent opacity-70" data-id="element-272"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6 mb-8" data-id="element-273">
          {/* Basic Plan Mini */}
          <div className="bg-graphite border border-white/10 rounded-2xl p-6 text-center hover:border-electric/30 transition-all" data-id="element-274">
            <h3 className="text-xl font-bold mb-2" data-id="element-275">📘 MEGAPACK FREELANCER</h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-276">
              6 Tomos + 6 Bonos · De 0 a Ingresos en USD
            </p>
            <div className="mb-6" data-id="element-277">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-278">
                $36.990
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-279">
                $19.990{' '}
                <span className="text-lg text-textsecondary font-medium" data-id="element-280">
                  ARS
                </span>
              </span>
            </div>
            <a href="#" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-petroleum to-petroleum/80 hover:from-electric/20 hover:to-electric/10 border border-electric/50 hover:border-electric text-white font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-electric/20" data-id="element-281">
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center group-hover:bg-electric/25 transition-colors" data-id="element-282">
                <Zap className="w-3.5 h-3.5 text-electric fill-electric" data-id="element-283" />
              </span>
              <span className="flex-1 text-center text-sm tracking-wide" data-id="element-284">
                QUIERO MI MEGAPACK
              </span>
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 text-electric flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-285">
                <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-286" />
              </span>
            </a>
          </div>

          {/* Pro Plan Mini */}
          <div className="bg-gradient-to-b from-[#1a1a1a] to-petroleum border-2 border-electric rounded-2xl p-6 text-center relative glow-electric" data-id="element-287">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-graphite font-bold px-3 py-0.5 rounded-full text-xs flex items-center gap-1" data-id="element-288">
              <Zap className="w-3 h-3 fill-graphite" data-id="element-289" /> MÁS POPULAR
            </div>
            <h3 className="text-xl font-bold mb-2 text-gold" data-id="element-290">
              🚀 MEGAPACK + FREELANCER PRO
            </h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-291">
              6 Tomos + 6 Bonos + El Sistema para Llegar a tus Primeros USD
              1.000
            </p>
            <div className="mb-6" data-id="element-292">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-293">
                $49.990
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-294">
                $27.990{' '}
                <span className="text-lg text-textsecondary font-medium" data-id="element-295">
                  ARS
                </span>
              </span>
            </div>
            <a href="#" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-gold via-gold to-gold hover:from-gold hover:via-gold hover:to-gold border border-gold text-graphite font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-gold/40" data-id="element-296">
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite/15 border border-graphite/20 flex items-center justify-center" data-id="element-297">
                <Zap className="w-3.5 h-3.5 text-graphite fill-graphite" data-id="element-298" />
              </span>
              <span className="flex-1 text-center text-sm tracking-wide" data-id="element-299">
                QUIERO EL COMBO COMPLETO
              </span>
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite text-gold flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-300">
                <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-301" />
              </span>
            </a>
          </div>
        </div>

        {/* Trust Row */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 text-sm text-textsecondary font-medium" data-id="element-302">
          <div className="flex items-center gap-2" data-id="element-303">
            <Lock className="w-5 h-5 text-electric" data-id="element-304" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-305">
            <Clock className="w-5 h-5 text-electric" data-id="element-306" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-307">
            <ShieldCheck className="w-5 h-5 text-electric" data-id="element-308" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-309">
            <CreditCard className="w-5 h-5 text-electric" data-id="element-310" /> Mercado Pago —
            Tarjeta — Transferencia
          </div>
        </div>
      </div>
    </section>;
}